<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>用户信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-select :value="queryType" @change="setQueryType" placeholder="请选择">
          <el-option
            v-for="item in queryTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-input
          placeholder="请输入内容"
          clearable
          v-model="queryValue"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button
          type="primary"
          @click="handleSearch"
        >搜索</el-button>
      </div>
      <user-list @refresh="refreshList"></user-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import UserList from './components/list';
import { mapState, mapActions, mapMutations } from 'vuex';
import { QUERY_TYPE, PAGINATION } from './constants';

export default {
  name: 'User',
  components: {
    UserList
  },
  data() {
    return {
      queryValue: ''
    };
  },
  computed: {
    ...mapState('user', ['queryType', 'queryTypeList', 'pagination'])
  },
  methods: {
    ...mapActions('user', ['list']),
    ...mapMutations('user', ['setQueryType']),
    refreshList(data = {}) {
      this.list({
        queryType: this.queryType,
        queryValue: this.queryValue,
        ...this.pagination,
        ...data
      });
    },
    handleSearch() {
      this.list({
        queryType: this.queryType,
        queryValue: this.queryValue,
        ...PAGINATION
      });
    }
  },
  created() {
    // this.list({
    //   queryType: QUERY_TYPE[0].value,
    //   queryValue: this.queryValue,
    //   ...PAGINATION
    // });
  }
};
</script>

<style lang="less" scoped>
</style>
